export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_clean-community-hub/artifacts/3wviyxtb_Picture%201.jpg";

export const FLAGS_URL =
  "https://customer-assets.emergentagent.com/job_clean-community-hub/artifacts/otgjki1c_image001.jpg";
